import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Fields.scss';

class Field extends React.Component {
  state = {
    value: this.props.value,
    error: false
  };

  componentWillReceiveProps(update) {
    this.setState({ value: update.value });
  }

  // onInputChange = evt => {
  //   const { value } = evt.target;
  //   const error = this.props.validate ? this.props.validate(value) : false;

  //   this.setState({ value, error });
  //   this.props.onInputChange(this.props.name, value, error);
  // };

  render() {
    const wrapperClass = classnames({
      'form-group': true,
      'has-error': this.state.error
    });

    return (
      <div className={wrapperClass}>
        <input className="form-control" value={this.state.value} />
      </div>
    );
  }
}

Field.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
  // onInputChange: PropTypes.func.isRequired
  // validate: PropTypes.func
};

Field.defaultProps = {
  validate: () => false
};

export default Field;
